/**
* A function that returns a slug for error translation
* @param {Object} errors   FieldErrors from images with profanity
* @returns {String}   Slug to look up error
*/
export function writeReviewProfanityFilter(errors) {
    if (typeof (errors) === 'object') {
        for (let key in errors) {
            if (Object.prototype.hasOwnProperty.call(errors, key)) {
                return errors[key].Code;
            }
        }
    }
}
